import { createAppTheme } from './create-app-theme';

export { createAppTheme } from './create-app-theme';
export type { AppThemeOptions } from './create-app-theme';
export { BRAND_COLORS } from './tokens';
export type { BrandColor, CorNomeada } from './tokens';
export { resolveCorName } from './palette';
export type { SidebarPalette } from './palette';

/** Tema da cor default, consumido pelos providers de topo (app e Storybook). */
export const theme = createAppTheme();
